module.exports = __webpack_public_path__ + "img/cash.46ac944e.png";